import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { OG_AUTH_EXPIRED_EVENT } from '@/api/opengater/tokens';
import { hasPanelSession } from './session';
// One login for the whole panel: the Opengater sign-in — or the panel's own SSO
// token, when one came back — opens every section. With neither, the operator
// gets the Opengater login: it works on any address the panel is served from,
// unlike the SSO, which only returns to the public one. The SSO callback itself
// is consumed in main.tsx before the first render.
export function ProtectedRoute() {
    const { pathname } = useLocation();
    const [, recheck] = useReducer((n) => n + 1, 0);
    useEffect(() => {
        window.addEventListener(OG_AUTH_EXPIRED_EVENT, recheck);
        return () => window.removeEventListener(OG_AUTH_EXPIRED_EVENT, recheck);
    }, []);
    const inOpengater = pathname === '/opengater' || pathname.startsWith('/opengater/');
    if (inOpengater || hasPanelSession())
        return _jsx(Outlet, {});
    return _jsx(Navigate, { to: "/opengater", replace: true });
}
